import {
  Divider,
  IconButton,
  makeStyles,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Toolbar,
  Typography
} from '@material-ui/core';
import {AddCircle, Edit, Delete, VisibilityOff, Visibility, Fingerprint, Check} from '@material-ui/icons';
import React, {RefObject, useEffect, useRef, useState} from 'react';
import { useHistory, useParams } from 'react-router-dom';
import Group from '../../../Domain/Models/Group';
import ErrorCardController from "../../UiComponents/ErrorCardController";
import Loading from "../../UiComponents/Loading";
import {predefinedRouteRepository} from "../../../Domain/Repositories/PredefinedRouteRepository";
import {groupRepository} from "../../../Domain/Repositories/GroupRepository";
import PredefinedRoute from "../../../Domain/Models/PredefinedRoute";

const useStyles = makeStyles((theme) => ({
  paper: {
    padding: theme.spacing(2),
    marginBottom: theme.spacing(2),
    display: 'flex',
    overflow: 'auto',
    flexDirection: 'column',
  },
  title: {
    flexGrow: 1
  },
  clickableCell: {
    cursor: 'pointer',
  },
}));


export interface PredefinedRouteContentProps
{
  group: Group;
  forceReload: () => void;
  showModal: (predefinedRoute?: PredefinedRoute) => void;
  errorCardControllerRef: RefObject<ErrorCardController>;
}

export default function PredefinedRouteContent(props: PredefinedRouteContentProps)
{
  const classes = useStyles();
  const history = useHistory();
  
  const {group, forceReload, showModal, errorCardControllerRef} = props;

  const [loading, setLoading] = useState(false);
  const [idVisible, setIdVisible] = useState(false);
  const [predefinedRoute, setPredefinedRoute] = useState<PredefinedRoute>();
  
  const handleAddEditPressed = () =>
  {
    showModal(predefinedRoute);
  }

  useEffect(() =>
  {
    setLoading(true);
    predefinedRouteRepository.load()
      .then(() => predefinedRouteRepository.getByGroupId(group.id))
      .then((x) =>
      {
        setPredefinedRoute(x);
        setLoading(false);
      })
      .catch((e: Error) =>
      {
        setLoading(false);
        errorCardControllerRef.current?.addErrorMessage(e.message);
      });

  }, []);

  return (
    <>
      <Loading isLoading={loading}>

        <Paper className={classes.paper}>
          <Toolbar>
            <Typography className={classes.title} component="h2" variant="h6" color="primary" gutterBottom>
              Predefined Route
            </Typography>
            <IconButton size="small" color="default" onClick={() => setIdVisible(!idVisible)}>
              { idVisible ? <VisibilityOff/> : <Visibility/> }
            </IconButton>
            {predefinedRoute === undefined ? (
              <IconButton size="small" color="default" onClick={handleAddEditPressed}>
                <AddCircle/>
              </IconButton>
            ) : (
              <IconButton size="small" color="default" onClick={handleAddEditPressed}>
                <Edit/>
              </IconButton>
            )}
          </Toolbar>

          <TableContainer>
            <Table>
              <TableHead>
                <TableRow>
                  <TableCell>Any Order?</TableCell>
                  <TableCell>
                    {predefinedRoute?.anyOrder && (
                      <Check />
                    )}
                  </TableCell>
                </TableRow>
              </TableHead>
            </Table>
          </TableContainer>
          
          <Divider />

          <TableContainer>
            <Table>
              <TableHead>
                <TableRow>
                  {idVisible && <TableCell>Cube ID</TableCell>}
                  <TableCell>#</TableCell>
                  <TableCell>Name</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {predefinedRoute?.route
                  .sort((a, b) => a.index < b.index ? -1 : 1)
                  .map((row, index) => (
                  <TableRow key={row.index} hover>
                    {idVisible && <TableCell scope="row">{row.cube.id}</TableCell>}
                    <TableCell>
                      {row.index}
                    </TableCell>
                    <TableCell>
                      {row.cube.name}
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>

        </Paper>
      </Loading>
    </>
  );
}